import { useCssStateManager } from "../../hooks/use_css_state_manager";
import { prebuildData } from "../../lib/prebuild-data";

export type NicotineWarningProps = {
};

export default function NicotineWarning({}:NicotineWarningProps)
{
    const cssStateManager = useCssStateManager(["nicotine-warning"]);

    const { nicotineWarningBox: { backgroundColor,borderColor,textColor } } = prebuildData.getActiveTheme();

    return (
        <>
            <div className={cssStateManager.getClassNames()}>
                <div className="outline">
                    <div className="warning">WARNING</div>
                    <div className="text-line">This product contains nicotine. Nicotine is an addictive chemical</div>
                </div>
            </div>
            <style jsx>{`
            .nicotine-warning {       
                background-color: ${backgroundColor};                                         
                color: ${textColor};
                text-align: center;
                margin-top: 20rem;            
                padding: 0rem 0rem;
            }
            .outline {                
                border: 3rem solid ${borderColor};
                padding: 10rem;
            }
            .warning {
                font-size: 15rem;
                font-weight: 600;
                padding-bottom: 2rem;            
            }
            .text-line {
                font-size: 12rem;
            }
            `}</style>
        </>
    );
}